window.recentlyViewedSectionLoaded = (product) => {
  product.querySelector('.product_listing_options')?.classList.add('hidden');
  
  product.querySelectorAll('.swatch').forEach(swatchDiv => {
    swatchDiv.querySelectorAll('input').forEach(inputElement => {
      inputElement.addEventListener('change', onVariantChange);
    });    
  });

  window.firstOptionValue = product.querySelectorAll('.swatch')[0]?.querySelector('input:checked').value;
  window.secondOptionValue = product.querySelectorAll('.swatch')[1]?.querySelector('input:checked').value;
  window.thirdOptionValue = product.querySelectorAll('.swatch')[2]?.querySelector('input:checked').value;

  product.querySelector('.variants-recently-viewed-cart-atc-button').addEventListener('click', onAddClick);

  product.querySelector('.variants-recently-viewed-cart')?.classList.remove('hidden');
  product.querySelector('.variants-recently-viewed-cart-atc-button')?.classList.remove('hidden');
};

const onVariantChange = (event) => {
  const swatchDiv = event.target.parentElement.parentElement;
  if ( swatchDiv.dataset.optionIndex === '1' ) {
    firstOptionValue = event.target.value;
  } else if ( swatchDiv.dataset.optionIndex === '2' ) {
    secondOptionValue = event.target.value;
  } else if ( swatchDiv.dataset.optionIndex === '3' ) {
    thirdOptionValue = event.target.value;
  }

  swatchDiv.querySelector('#selected-option-1').textContent = event.target.value;

  let selectedVariantName = '';
  if ( firstOptionValue ) selectedVariantName = firstOptionValue;
  if ( secondOptionValue ) selectedVariantName += ' / ' + secondOptionValue;
  if ( thirdOptionValue ) selectedVariantName += ' / ' + thirdOptionValue;

  const container = swatchDiv.parentElement.parentElement;
  container.querySelector('.variants-selectbox').value = container.querySelector('.variants-selectbox [data-variant-title="'+selectedVariantName+'"]').value;

  const variantData = JSON.parse(container.querySelector('.variants-selectbox [data-variant-title="'+selectedVariantName+'"]').dataset.config);
  const price = variantData.price;
  const comparePrice = variantData.compare_at_price;
  const formattedPrice = Shopify.formatMoney(price, Shopify.money_format);
  const formattedComparePrice = Shopify.formatMoney(comparePrice, Shopify.money_format);

  if ( comparePrice && price !== comparePrice ) {
    container.parentElement.querySelector('.price--listing .price__sale .price-item--sale').textContent = formattedPrice;
    container.parentElement.querySelector('.price--listing .price__sale .price-item--regular').textContent = formattedComparePrice;
    container.parentElement.querySelector('.price--listing').classList.add('price--on-sale');
    container.parentElement.parentElement.parentElement.querySelector('.sale-item').classList.remove('hidden');
  } else {
    container.parentElement.querySelector('.price--listing .price__regular .price-item--regular').textContent = formattedPrice;
    container.parentElement.querySelector('.price--listing').classList.remove('price--on-sale');
    container.parentElement.parentElement.parentElement.querySelector('.sale-item').classList.add('hidden');
  }

  // code for custom add to cart added by milan
  if ( !variantData.available ) {
    container.parentElement.querySelector('.variants-recently-viewed-cart-atc-button').setAttribute('disabled', 'disabled');
    container.parentElement.querySelector('.variants-recently-viewed-cart-atc-button').textContent = 'Sold Out';
    
    // container.parentElement.querySelector('.AddtoCart_value_mlv').setAttribute('disabled', 'disabled');
    // container.parentElement.querySelector('.AddtoCart_value_mlv').textContent = 'Sold Out';
  } else {
    container.parentElement.querySelector('.variants-recently-viewed-cart-atc-button').removeAttribute('disabled');
    container.parentElement.querySelector('.variants-recently-viewed-cart-atc-button').textContent = 'Add To Cart';
    
    // container.parentElement.querySelector('.AddtoCart_value_mlv').removeAttribute('disabled');
    // container.parentElement.querySelector('.AddtoCart_value_mlv').textContent = 'Add To Cart';
  }
  // code for custom add to cart added by milan
};

const onAddClick = (event) => {
  const selectedVariantId = event.target.parentElement.querySelector('.variants-selectbox').value;
  const formData = {
   'items': [{
    'id': selectedVariantId,
    'quantity': 1
    }]
  };
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    window.location.reload();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
};
document.addEventListener("DOMContentLoaded", (event) => {
   var count = document.querySelector('#ymm_garage_link .ymm_counter');
  var marginElem = document.querySelector('#flex-header ul#cart li.ymm_garage_container')
    if(count){
      if(count.innerHTML == 0){ 
        console.log(marginElem)
        count.style.display = 'none';
        marginElem.style="margin-right: 10px;"
      }else{
        count.style.display = 'inline-flex';
        marginElem.style="margin-right: 26px;"
      }
    }
    var x = document.querySelector('#flex-header a.cart-icon .js-cart-count')
    if(x){
      if(Number.parseInt(x.innerHTML) == 0){
          x.style.display="none";
      }
      if(Number.parseInt(x.innerHTML) > 0){
          x.style.display="block";
      }
    }
});

/* Added on 27/1/25 start */
if ($(window).width() <= 767) {
    $(document).on("click", "#add_ymm_vehicle", function() {
        // Remove the href attribute from the button
        $(this).removeAttr("href");

        // Trigger the click logic
        var ml_interval = setInterval(function() {
            $("#ymm_label").trigger("click"); 
        }, 1000);

        // Clear the interval after 1 second
        setTimeout(function() {
            clearInterval(ml_interval);
        }, 1000);
    });
}
/* Added on 27/1/25 end */
/* Added on 17/3/25 start */


// code for quick buy : start 
// document.addEventListener("DOMContentLoaded", function () {
//   const addToCartButtons = document.querySelectorAll(".AddtoCart_quickBuy");
//   const filters = document.querySelectorAll(".js-collection-side-filter");
//   console.log("addToCartButtons : ",addToCartButtons);
  
//     if (addToCartButtons.length > 0) {
//         addToCartButtons.forEach(addToCartButton => {
//             console.log("addToCartButton : ", addToCartButton);
            
//             addToCartButton.addEventListener('click', function (event) {
//                 event.preventDefault();
                
//                 // Find the nearest .product-index and get the variant ID
//                 let productIndex = this.closest(".product-index");
//                 if (!productIndex) {
//                     console.error("Error: .product-index not found.");
//                     return;
//                 }

//                 let variantId = productIndex.getAttribute("data-variant-id");
//                 if (!variantId) {
//                     console.error("Error: Variant ID not found.");
//                     return;
//                 }

//                 const properties = {};
//                 const propertyInputs = document.querySelectorAll('input[name^="properties["]');
            
//                 propertyInputs.forEach(input => {
//                     const name = input.getAttribute('name').replace(/^properties\[/, '').replace(/\]$/, ''); // Extract property name
//                     properties[name] = input.value;
//                 });
            
//                 console.log("Collected Properties: ", properties);

//                 let items = [{ id: variantId, quantity: 1, properties: properties }];

//                 // Add the product to cart
//                 fetch('/cart/add.js', {
//                     method: 'POST',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify({ items })
//                 })
//                 .then(response => response.json())
//                 .then(() => {
//                     console.log("Items added, fetching updated cart...");

//                     // Fetch updated cart data
//                     return fetch('/cart.js').then(response => response.json());
//                 })
//                 .then(cartData => {
//                     let totalQuantity = cartData.item_count;
//                     console.log("Updated Total Quantity in Cart:", totalQuantity);

//                     // Update all cart count elements
//                     const MLV_add_to_carts = document.querySelectorAll(".MLV_add_to_cart");
//                     MLV_add_to_carts.forEach(i => {
//                         const cart_count = i.querySelector(".js-cart-count");
//                         if (cart_count) {
//                             cart_count.innerHTML = totalQuantity;
//                         }

//                         // Simulate click on add-to-cart button
//                         setTimeout(() => {
//                             i.dispatchEvent(new Event('click'));
//                         }, 500);
//                     });

//                 })
//                 .catch(error => {
//                     console.error("Error updating cart:", error);
//                 });
//             });
//         });
//     }
// });

document.addEventListener("DOMContentLoaded", function () {
    // const filters = document.querySelectorAll(".js-collection-side-filter");

    function attachAddToCartEvents() {
        const addToCartButtons = document.querySelectorAll(".AddtoCart_quickBuy");

        addToCartButtons.forEach(addToCartButton => {
            addToCartButton.addEventListener("click", function (event) {
                event.preventDefault();

                let productIndex = this.closest(".product-index");
                if (!productIndex) {
                    console.error("Error: .product-index not found.");
                    return;
                }

                let variantId = productIndex.getAttribute("data-variant-id");
                if (!variantId) {
                    console.error("Error: Variant ID not found.");
                    return;
                }

                const properties = {};
                const propertyInputs = document.querySelectorAll('input[name^="properties["]');
                propertyInputs.forEach(input => {
                    const name = input.getAttribute('name').replace(/^properties\[/, '').replace(/\]$/, '');
                    properties[name] = input.value;
                });

                console.log("Collected Properties: ", properties);

                let items = [{ id: variantId, quantity: 1, properties: properties }];

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items })
                })
                .then(response => response.json())
                .then(() => fetch('/cart.js').then(response => response.json()))
                .then(cartData => {
                    let totalQuantity = cartData.item_count;
                    console.log("Updated Total Quantity in Cart:", totalQuantity);

                    document.querySelectorAll(".MLV_add_to_cart").forEach(i => {
                        const cart_count = i.querySelector(".js-cart-count");
                        if (cart_count) {
                            cart_count.innerHTML = totalQuantity;
                        }

                        setTimeout(() => {
                            i.dispatchEvent(new Event('click'));
                        }, 500);
                    });

                })
                .catch(error => console.error("Error updating cart:", error));
            });
        });
    }

    attachAddToCartEvents(); // Attach on initial load

    // filters.forEach(filter => {
    //     const label = filter.querySelector("label");
    //     label.addEventListener("click", function () {
    //         setTimeout(() => {
    //             attachAddToCartEvents(); // Reattach after filter updates
    //         }, 1000);
    //     });
    // });

    // MutationObserver setup
    function observeChanges(target) {
        if (!target) return;

        const observerId = new MutationObserver((mutationsList) => {
            for (let mutation of mutationsList) {
                if (mutation.type === "childList" || mutation.type === "subtree") {
                    if (document.querySelector(".AddtoCart_quickBuy")) {
                        attachAddToCartEvents();
                        break; // No need to check further if button is found
                    }
                }
            }
        });

        observerId.observe(target, { childList: true, subtree: true });
    }

    // Observe changes in #CollectionProductGrid and #predictive-search
    observeChanges(document.getElementById("CollectionProductGrid"));
    observeChanges(document.getElementById("predictive-search"));
});
// code for quick buy : end 

// code for update sku, barcode : start
// document.addEventListener("DOMContentLoaded", function() {
//   const mlv_radio_labels = document.querySelectorAll(".mlv_radio_label");
//   const variant_barcode_mlv = document.querySelector(".variant-barcode_mlv");
//   const variant_sku_mlv = document.querySelector(".variant-sku_mlv");
//   const AddtoCart_value_mlvs = document.querySelectorAll(".AddtoCart_value_mlv");
//   const mlv_title = document.querySelector(".mlv_title");
 
//   if(mlv_title) {
//     if(AddtoCart_value_mlvs.length > 0) {
//       AddtoCart_value_mlvs.forEach((AddtoCart_value_mlv) => {
//         if(AddtoCart_value_mlv) {
//           AddtoCart_value_mlv.value = `Add to Cart - ${document.querySelector("#totalCost span").innerText}`;
//         }
//       });
//     }
//   }
//   else {
//     if(AddtoCart_value_mlvs.length > 0) {
//       AddtoCart_value_mlvs.forEach((AddtoCart_value_mlv) => {
//         if(AddtoCart_value_mlv) {
//           AddtoCart_value_mlv.value = `Add to Cart - ${document.querySelector(".price-item.price-item--regular").innerText}`;
//         }
//       });
//     }
    
//   }
  
//   if(mlv_radio_labels.length > 0) {
//     mlv_radio_labels.forEach((input) => {
//       input.addEventListener("click", function() {
//         setTimeout(() => {
//           if(variant_barcode_mlv) {
//             variant_barcode_mlv.innerText = `UPC: ${document.querySelector(".mlv_radio_input:checked").getAttribute("data-variant-barcode")}`;
//           }
//           if(variant_sku_mlv) {
//             variant_sku_mlv.innerText = `SKU: ${document.querySelector(".mlv_radio_input:checked").getAttribute("data-variant-sku")}`;
//           }

//           if(mlv_title) {
//             if(AddtoCart_value_mlvs.length > 0) {
//               AddtoCart_value_mlvs.forEach((AddtoCart_value_mlv) => {
//                 if(AddtoCart_value_mlv) {
//                   AddtoCart_value_mlv.value = `Add to Cart - ${document.querySelector("#totalCost span").innerText}`;
//                 }
//               });
//             }
//           }
//           else {
//             if(AddtoCart_value_mlvs.length > 0) {
//               AddtoCart_value_mlvs.forEach((AddtoCart_value_mlv) => {
//                 if(AddtoCart_value_mlv) {
//                   AddtoCart_value_mlv.value = `Add to Cart - ${document.querySelector(".price-item.price-item--regular").innerText}`;
//                 }
//               });
//             }
//           }

//         },300);
//       });
//     });
//   }
//   updateSelectedProducts();
// });

// Attach event listeners for variant changes
document.addEventListener("DOMContentLoaded", function () {
  const mlv_radio_labels = document.querySelectorAll(".mlv_radio_label");
  const mlv_radio_input = document.querySelectorAll(".mlv_radio_input");
  const variant_barcode_mlv = document.querySelector(".variant-barcode_mlv");
  const variant_sku_mlv = document.querySelector(".variant-sku_mlv");
  const AddtoCart_value_mlvs = document.querySelectorAll(".AddtoCart_value_mlv");
  const mlv_title = document.querySelector(".mlv_title");

  // Update Add to Cart button on page load
  if (mlv_title) {
    AddtoCart_value_mlvs.forEach((btn) => {
      btn.value = `Add to Cart - ${document.querySelector("#totalCost span")?.innerText || "$0.00"}`;
    });
  } else {
    // code commented by Milan 
    // AddtoCart_value_mlvs.forEach((btn) => {
    //   btn.value = `Add to Cart - ${document.querySelector(".price-item.price-item--regular")?.innerText || "$0.00"}`;
    // });
    // code commented by Milan 
  }


   mlv_radio_input.forEach((input) => {
    input.addEventListener("change", function () {
      setTimeout(() => {
      if(window.location.href.includes('variant=')){
        let currentVariantId = window.location.href.split('variant=')[1]
        let sectionId = document.querySelector('.product-page.product-template').getAttribute('data-section-id')
        fetch(window.location.pathname+`?variant=${currentVariantId}&sections_id=${sectionId}`)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const productNew = parser.parseFromString(html, "text/html");
            // document.querySelector('.product-blocks__block--quantity').innerHTML = productNew.querySelector('.product-blocks__block--quantity').innerHTML;
            // document.querySelector('.mlv-sticky-addbtn').innerHTML = productNew.querySelector('.mlv-sticky-addbtn').innerHTML;
            const newQuantityBlock = productNew.querySelector('.product-blocks__block--quantity');
            const newStickyBtn = productNew.querySelector('.mlv-sticky-addbtn');
            const newPreorderTextBlock = productNew.querySelector('.mlveda-preorder-text-below-atc');
            
        
            const oldQuantityBlock = document.querySelector('.product-blocks__block--quantity');
            const oldStickyBtn = document.querySelector('.mlv-sticky-addbtn');
            const oldPreorderTextBlock = document.querySelector('.mlveda-preorder-text-below-atc');
        
            if (oldQuantityBlock && newQuantityBlock) {
              oldQuantityBlock.replaceWith(newQuantityBlock);
            }
        
            if (oldStickyBtn && newStickyBtn) {
              oldStickyBtn.replaceWith(newStickyBtn);
            }
            if (oldPreorderTextBlock && newPreorderTextBlock) {
              oldPreorderTextBlock.replaceWith(newPreorderTextBlock);
            }
            // document.querySelector('.mainPrice').value = productNew.querySelector('.mainPrice').value;
            
            // if (mlv_title) {
            //   AddtoCart_value_mlvs.forEach((btn) => {
            //     btn.value = `Add to Cart - ${document.querySelector("#totalCost span")?.innerText || "$0.00"}`;
            //   });
            // } else {
            //   AddtoCart_value_mlvs.forEach((btn) => {
            //     btn.value = `Add to Cart - ${document.querySelector(".price-item.price-item--regular")?.innerText || "$0.00"}`;
            //   });
            // }
             document.querySelectorAll('.AddtoCart').forEach((btn) => {
              let btnValue = btn.value
              let btnvalues = btnValue.split('-')
              btnvalues[1] = document.querySelector("#totalCost span")?.innerText || "$0.00";
              btn.value = btnvalues.join('- ');
              console.log(btn.value, 'btn-val updated')
            })
            
            const addToCartButtons = document.querySelectorAll('.AddtoCart');
            if (addToCartButtons.length > 0) {
              addToCartButtons.forEach(addToCartButton => {
                  console.log("addToCartButton : ",addToCartButton);
                  addToCartButton.addEventListener('click', function(event) {
                  event.preventDefault();
                  addSelectedProductsToCart();
                });
              });
            }
        })
      }
      })
    })
  })
  
  // Attach event listener to radio button selection
  mlv_radio_labels.forEach((input) => {
    input.addEventListener("click", function () {
      setTimeout(() => {
        // Update barcode and SKU
        /* commented by mlveda on 12/3/25 start */
        /* if (variant_barcode_mlv) {
          variant_barcode_mlv.innerText = `UPC: ${document.querySelector(".mlv_radio_input:checked")?.getAttribute("data-variant-barcode") || "N/A"}`;
        }
        if (variant_sku_mlv) {
          variant_sku_mlv.innerText = `SKU: ${document.querySelector(".mlv_radio_input:checked")?.getAttribute("data-variant-sku") || "N/A"}`;
        } */
        /* commented by mlveda on 12/3/25 end */

        // Update "Add to Cart" button value
        // code commented by Milan
        // if (mlv_title) {
        //   AddtoCart_value_mlvs.forEach((btn) => {
        //     btn.value = `Add to Cart - ${document.querySelector("#totalCost span")?.innerText || "$0.00"}`;
        //   });
        // } else {
        //   AddtoCart_value_mlvs.forEach((btn) => {
        //     btn.value = `Add to Cart - ${document.querySelector(".price-item.price-item--regular")?.innerText || "$0.00"}`;
        //   });
        // }
        // code commented by Milan

        // **Call updateSelectedProducts to update the price dynamically**
        updateSelectedProducts();

      }, 300);
    });
  });

  // Initial update on page load
  updateSelectedProducts();
});
// code for update sku, barcode : end
// code for sticky add to cart on the product page : start
// document.addEventListener("DOMContentLoaded", function () {
//     const buttonBlock = document.querySelector(".template-product .product-blocks__block--buttons .mlv-sticky-addbtn");
//     if (!buttonBlock) return;
//     if (window.innerWidth > 768) return; // Apply only on mobile
//     const offset = buttonBlock.offsetTop;    
//     function handleScroll() {

//         const buttonwishlistBlock = document.querySelector(".template-product .product-blocks__block--buttons .mlv-sticky-addbtn .swym-button-bar");        
//         if (!buttonwishlistBlock) return; // Ensure the element exists before applying styles

//         if (window.scrollY > offset) {
//             buttonBlock.style.position = "sticky";
//             buttonBlock.style.width = "unset";
//             buttonwishlistBlock.style.display = "inline-block";
//         } else {
//             buttonBlock.style.position = "";
//             // buttonBlock.style.width = "90%";
//           buttonBlock.style.width = "";
//           buttonwishlistBlock.style.display = "none";
//         }
//     }

//   // Interval to check if buttonwishlistBlock exists
//     const checkInterval = setInterval(() => {
//         const buttonwishlistBlock = document.querySelector(".template-product .product-blocks__block--buttons .mlv-sticky-addbtn .swym-button-bar");
//         if (buttonwishlistBlock) {
//             buttonwishlistBlock.style.display = "inline-block";
//             clearInterval(checkInterval); // Stop checking once found
//         }
//     }, 500); // Check every 500ms
  
//     window.addEventListener("scroll", handleScroll);
// });

/* Original code commented by mlveda on 30/6/26 document.addEventListener("DOMContentLoaded", function () {
    const buttonBlock = document.querySelector(".template-product .product-blocks__block--buttons .mlv-sticky-addbtn");
    if (!buttonBlock) return;
    if (window.innerWidth > 768) return; // Apply only on mobile

    let lastScrollTop = window.scrollY; // Store last scroll position

    function handleScroll() {
        let currentScroll = window.scrollY;

        const buttonwishlistBlock = document.querySelector(".template-product .product-blocks__block--buttons .mlv-sticky-addbtn .swym-button-bar");
        if (!buttonwishlistBlock) return; // If the button is not found, do nothing

        if (currentScroll > lastScrollTop) {
            // Scrolling down -> Show the wishlist button and make it sticky
            buttonBlock.style.position = "sticky";
            buttonBlock.style.width = "unset";
            buttonwishlistBlock.style.display = "inline-block";
        } else {
            // Scrolling up -> Hide the wishlist button and reset position
            buttonBlock.style.position = "";
            buttonBlock.style.width = "";
            buttonwishlistBlock.style.display = "none";
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Prevent negative values
    }

    // Observe changes in the button container to detect when the wishlist button is added
    const observer = new MutationObserver(() => {
        const buttonwishlistBlock = document.querySelector(".template-product .product-blocks__block--buttons .mlv-sticky-addbtn .swym-button-bar");
        if (buttonwishlistBlock) {
            buttonwishlistBlock.style.display = "none"; // Initially hide the wishlist button
            window.addEventListener("scroll", handleScroll);
            observer.disconnect(); // Stop observing once the button is found
        }
    });

    observer.observe(buttonBlock, { childList: true, subtree: true });
});*/
document.addEventListener("DOMContentLoaded", function () {
  let stickyBtnWrapper = null;
  let originalOffsetTop = 0;

  function updateElement() {
    const currentElement = document.querySelector(".mlv-sticky-addbtn");

    // Recalculate only if Shopify replaced the element
    if (currentElement !== stickyBtnWrapper) {
      stickyBtnWrapper = currentElement;

      if (stickyBtnWrapper) {
        originalOffsetTop =
          stickyBtnWrapper.getBoundingClientRect().top + window.scrollY;
      }
    }
  }

  function handleScroll() {
    updateElement();

    if (!stickyBtnWrapper) return;

    if (window.innerWidth <= 767) {
      stickyBtnWrapper.classList.add("fixed");
    } else {
      if (window.scrollY > originalOffsetTop) {
        stickyBtnWrapper.classList.add("fixed");
      } else {
        stickyBtnWrapper.classList.remove("fixed");
      }
    }
  }

  handleScroll();

  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", handleScroll);

  const observer = new MutationObserver(() => {
    updateElement();
    handleScroll();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
// code for sticky add to cart on the product page : end

// code for add heading on the groupmate app section on the product page : start(28/1/26)
(function () {
  const HEADING_ID = 'groupmate-heading';

  function addHeadingIfNeeded(groupmateEl) {
    if (!groupmateEl) return;

    const ul = groupmateEl.querySelector('ul');
    if (!ul || ul.children.length === 0) return;

    // Prevent duplicate heading
    if (groupmateEl.querySelector('#' + HEADING_ID)) return;

    const h2 = document.createElement('h2');
    h2.id = HEADING_ID;
    h2.textContent = 'Related Bundles';

    h2.style.fontWeight = '800';
    h2.style.fontSize = '16px';
    h2.style.fontStyle = 'var(--main-style)';
    h2.style.lineHeight = '25.4px';
    h2.style.fontFamily = 'var(--main-family)';
    h2.style.letterSpacing = 'var(--button-spacing)';
    h2.style.padding = '0px 0 0px 10px';
  
    groupmateEl.insertBefore(h2, ul);
  }

  // Observe DOM because app embed loads async
  const observer = new MutationObserver(() => {
    const groupmate = document.querySelector('.groupmate');
    if (groupmate) {
      addHeadingIfNeeded(groupmate);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
// code for add heading on the groupmate app section on the product page : end(28/1/26)
// code for set the google rating and beacon widget in one row: start(5/2/26)
//  (function () {
//     function applyGoogleWidgetStyles() {
//       var el = document.getElementById('google-merchantwidget-iframe-wrapper');
//       if (el) {
//         el.style.position = 'fixed';
//         el.style.right = '84px';
//         el.style.bottom = '-6px';
//         return true;
//       }
//       return false;
//     }

//     // Try once after full page load
//     window.addEventListener('load', function () {
//       if (applyGoogleWidgetStyles()) return;

//       // Observe DOM changes if element loads later
//       var observer = new MutationObserver(function () {
//         if (applyGoogleWidgetStyles()) {
//           observer.disconnect();
//         }
//       });

//       observer.observe(document.body, {
//         childList: true,
//         subtree: true
//       });
//     });
//   })();
(function () {
  const TARGET_ID = 'google-merchantwidget-iframe-wrapper';
  // const RIGHT_VALUE = '84px';
    // commented on 21/9/26 const RIGHT_VALUE = '110px';
  const RIGHT_VALUE = '4px';
  const BOTTOM_VALUE = '-6px';
  // commented on 21/9/26 const Z_INDEX = '2147483';

  function forceStyles(el) {
    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('right', RIGHT_VALUE, 'important');
    el.style.setProperty('bottom', BOTTOM_VALUE, 'important');
    el.style.setProperty('z-index', Z_INDEX, 'important');
  }

  function init() {
    const el = document.getElementById(TARGET_ID);
    if (!el) return false;

    // Apply immediately
    forceStyles(el);

    // Watch for app style changes
    const observer = new MutationObserver(() => {
      forceStyles(el);
    });

    observer.observe(el, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    return true;
  }

  window.addEventListener('load', () => {
    // Keep retrying until element exists
    const interval = setInterval(() => {
      if (init()) clearInterval(interval);
    }, 300);
  });
})();
// code for set the google rating and beacon widget in one row: end(5/2/26)